import React from 'react'
import Link from 'gatsby-link'
import logo from '../assets/images/logo.png'

const Header = (props) => (
    <header id="header" className="">
        {/*<Link to="/" className="logo"><img src={logo} alt="Imbibe - A Brand Design Firm"/></Link>*/}
        <Link to="/" className="logo">IMBIBE</Link>
        <nav>
            <a className="menu-link" onClick={props.onToggleMenu} href="javascript:;"></a>
        </nav>
    </header>
)

Header.propTypes = {
    onToggleMenu: React.PropTypes.func
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js